<template>
  <div class="ccui-app-container ccui-purchase-daily">
    <div class="ccui-advanced-search-wrapper ccui-clearfix">
      <el-search
        :formProp="formData"
        @search="searchItem"
        :isShowSearch="isShowSearch"
        class="ccui-highsearch no-print"
        :selectClear="true"
        width="460px"
      >
        <div class="ccui-tab-wrapper">
          <el-button type="table-top-active" size="mini"
            >商品采购统计表</el-button
          >
        </div>
        <div class="ccui-extend-btn">
          <el-button
            size="mini"
            type="primary"
            icon="icon-ccui-export"
            style="float: right;"
            @click="handlExport"
            >导出</el-button
          >
          <el-button
            size="mini"
            type="primary"
            icon="icon-ccui-print"
            style="float: right;margin-right: 10px;"
            @click="handlePrint"
            >打印</el-button
          >
        </div>
        <template slot="search">
          <el-input
            v-model="formData.orgName"
            clearable
            searchLabel="经办单位"
            placeholder="请输入经办单位模糊查询"
          ></el-input>
          <el-date-picker
            v-model="formData.orderDate"
            searchLabel="订单日期"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-input
            v-model="formData.prefecture"
            clearable
            searchLabel="专区"
            placeholder="请输入专区模糊查询"
          ></el-input>
          <el-input
            v-model="formData.commodity"
            clearable
            searchLabel="商品"
            placeholder="请输入商品模糊查询"
          ></el-input>
          <el-input
            v-model="formData.orderQuantity"
            clearable
            searchLabel="订单数（笔）"
            placeholder="请输入订单数模糊查询"
          ></el-input>
          <el-input
            v-model="formData.purchaseAmount"
            clearable
            searchLabel="累计采购金额（元）"
            placeholder="请输入累计采购金额模糊查询"
          ></el-input>
        </template>
        <el-input
          v-model="formData.orgName"
          clearable
          searchLabel="经办单位"
          placeholder="请输入经办单位模糊查询"
          slot="searchItem1"
        ></el-input>
        <el-date-picker
          v-model="formData.orderDate"
          searchLabel="订单日期"
          clearable
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          slot="searchItem2"
        >
        </el-date-picker>
        <el-input
          v-model="formData.prefecture"
          clearable
          searchLabel="专区"
          placeholder="请输入专区模糊查询"
          slot="searchItem3"
        ></el-input>
        <el-input
          v-model="formData.commodity"
          clearable
          searchLabel="商品"
          placeholder="请输入商品模糊查询"
          slot="searchItem4"
        ></el-input>
        <el-input
          v-model="formData.orderQuantity"
          clearable
          searchLabel="订单数（笔）"
          placeholder="请输入订单数模糊查询"
          slot="searchItem5"
        ></el-input>
        <el-input
          v-model="formData.purchaseAmount"
          clearable
          searchLabel="累计采购金额（元）"
          placeholder="请输入累计采购金额模糊查询"
          slot="searchItem6"
          formClass="ccui-pre-form"
        ></el-input>
      </el-search>
    </div>
    <!--startprint-->
    <div class="ccui-multifunctional-table-wrapper">
      <el-card-title
        :content-text="content"
        style="width: auto;margin: 0"
        class="no-screen"
        title="商品采购统计表"
      />
      <el-table
        :style="style"
        align="center"
        ref="listDataTable"
        :data="tableData"
        :isshow="true"
        :summary-method="getSummaries"
        :load="loadNode"
        :max-height="20000"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        lazy
        row-key="orgId"
        show-summary
        border
        class="ccui-multifunctional-table"
        @cell-click="clickCell"
        @header-dragend="headerDragend"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          type="index"
          label="序号"
          width="48"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          prop="orgName"
          label="经办单位"
          :min-width="allWidth.orgNameWidth"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          prop="orderDate"
          label="订单日期"
          :width="allWidth.orderDateWidth"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          prop="prefecture"
          label="专区"
          :width="allWidth.prefectureWidth"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="commodity"
          label="商品"
          :width="allWidth.commodityWidth"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="orderQuantity"
          label="订单数(笔)"
          :width="allWidth.orderQuantityWidth"
          align="right"
          header-align="left"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="purchaseAmount"
          label="累计采购金额(元)"
          :width="allWidth.purchaseAmountWidth"
          align="right"
          header-align="left"
        >
          <template slot-scope="scope">
            {{ numberFilter(scope.row.purchaseAmount).newNum }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--endprint-->
  </div>
</template>

<script>
require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.keys");
require("regenerator-runtime/runtime");
require("core-js/modules/es.object.values");
require("core-js/modules/es.object.set-prototype-of");
require("core-js/modules/es.array.find");
require("core-js/modules/es.array-buffer.is-view");
require("core-js/modules/es.weak-map");
require("core-js/modules/es.promise");
const ExcelJS = require("exceljs");
import { saveAs } from "file-saver";
import { getData } from "../api/product-purchase-collect";
import { numberFilter, ishasAgentId } from "@/basa/utils";

export default {
  name: "productPurchaseCollect",
  data() {
    return {
      // Todo tabs页签标识
      isFocus: 1,
      // Todo 表格数据 start
      content: "制表单位/制表人/日期：中交信科/游欢欢 2019.04.01",
      style: "",
      tableData: [],
      excelArr: [],
      acfun: false,
      input: "",
      tableParams: {
        parentId: -1,
        orgId: 2
      },
      searchData: "",
      filedData: {},
      isComeIn: false,
      allWidth: {
        // 经办单位
        orgNameWidth: 120,
        // 订单日期
        orderDateWidth: 100,
        // 专区
        prefectureWidth: 100,
        // 商品
        commodityWidth: 100,
        // 订单数(笔)
        orderQuantityWidth: 100,
        // 累计采购金额(元)
        purchaseAmountWidth: 140
      },
      tableHack: true,
      // Todo 表格数据 end

      // Todo 高级搜索数据 start
      formData: {
        orgName: "",
        orderDate: [],
        prefecture: "",
        commodity: "",
        orderQuantity: "",
        purchaseAmount: ""
      },
      isShowSearch: true
      // Todo 高级搜索数据 end
    };
  },
  updated() {
    this.expandAll();
  },
  created() {
    let obj = {
      medium: {
        orgNameWidth: 160,
        orderDateWidth: 130,
        prefectureWidth: 130,
        commodityWidth: 130,
        orderQuantityWidth: 130,
        purchaseAmountWidth: 160
      },
      large: {
        orgNameWidth: 190,
        orderDateWidth: 150,
        prefectureWidth: 150,
        commodityWidth: 150,
        orderQuantityWidth: 150,
        purchaseAmountWidth: 190
      }
    };
    if (window.screen.width >= 1400 && window.screen.width < 1960) {
      this.allWidth = { ...this.allWidth, ...obj.medium };
    } else if (window.screen.width >= 1960) {
      this.allWidth = { ...this.allWidth, ...obj.large };
    }
  },
  mounted() {
    this.getData();
  },
  deactivated() {
    window.onresize = null;
  },
  methods: {
    // Todo 表格所需函数 start
    expandAll() {
      const els = document.getElementsByClassName("el-table__expand-icon");
      if (els.length === 0) {
        return;
      }
      if (this.isComeIn) {
        return false;
      }
      this.isComeIn = true;
      els[0].click();
    },
    clickCell(row, column) {
      if (column.label === "采购单位") {
        const listTitleDom = document.body.querySelectorAll(
          ".el-tooltip__popper"
        );
        listTitleDom[0].style.display = "none";
        for (let i = 0; i < listTitleDom.length - 1; i++) {
          listTitleDom[i].style.display = "none";
        }
        this.$router.push({
          path: "/statistic/order/purchaser/order-detail/" + row.orgId
        });
      }
    },
    loadNode(tree, treeNode, resolve) {
      this.tableParams.parentId = tree.orgId;
      this.getData(resolve);
    },
    getSummaries(param) {
      const { data } = param;
      if (!data.length) return ["合计", "——", "——", "——", "——", 0, 0];
      const { orderQuantitySum, purchaseAmountSum } = data[0];
      return [
        "合计",
        "——",
        "——",
        "——",
        "——",
        orderQuantitySum,
        purchaseAmountSum
      ];
    },
    getData(resolve) {
      this.tableParams.isShowPageLoading = !resolve;
      let tableParams = this.tableParams;
      tableParams = { ...tableParams, ...this.searchData };
      getData(tableParams)
        .then(res => {
          if (res.data.code === "0") {
            this.filedData = res.data;
            !resolve && (this.tableData = res.data.data.rows);
            const filedArr = ["orderQuantitySum", "purchaseAmountSum"];
            console.log(res.data.data.rows);
            res.data.data.rows.forEach(item => {
              item.purchaseAmountSum = numberFilter(
                this.filedData.data.purchaseAmountSum
              ).newNum;
              item.orderQuantitySum = this.filedData.data.orderQuantitySum;
              filedArr.forEach(filed => {
                item[filed + "s"] = numberFilter(item[filed]).oldNum;
                if (filed.includes("Num")) {
                  item[filed] = numberFilter(item[filed], true).newNum;
                } else {
                  item[filed] = numberFilter(item[filed]).newNum;
                  // console.log(item[filed]);
                }
              });
              item.hasChildren = true;
              item.specialArea = "工程专区";
            });
            if (this.excelArr.length) {
              for (let i = 0; i < this.excelArr.length; i++) {
                if (this.excelArr[i].orgId === this.tableParams.parentId) {
                  this.excelArr.splice(i + 1, 0, ...res.data.data.rows);
                  break;
                }
              }
            } else {
              this.excelArr.push(...res.data.data.rows);
            }
          }
          resolve && resolve(res.data.data.rows);
        })
        .catch(err => {
          resolve && resolve([]);
        });
    },
    handlePrint() {
      let thead = document.createElement("thead");
      thead.innerHTML = `<thead>
      <tr style="border:1px solid #EDF2FC;height: 37px">
        <th style="border-right:none;padding-left:10px">序号</th>
        <th style="border-right:none;padding-left:5px">经办单位</th>
        <th style="border-right:none;padding-left:5px">订单日期</th>
        <th style="border-right:none;padding-left:5px">专区</th>
        <th style="border-right:none;padding-left:5px">商品</th>
        <th style="border-right:none;padding-left:5px">订单数</th>
        <th style="border-right:none;padding-left:5px">累计采购金额(元)</th>
      </tr>
      </thead>`;
      let acfun = document.getElementsByClassName("el-table__body")[0];
      acfun.appendChild(thead);
      this.acfun = true;
      this.$nextTick(() => {
        window.print();
      });
    },
    // 导出excel，ExcelJS版
    async exportDefault() {
      const wb = new ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("商品采购统计表");
      ws1.views = [{ state: "frozen", ySplit: 4 }];
      ws1.addRow(["商品采购统计表"]);
      ws1.addRow([this.userInfo]);
      ws1.getRow(3).values = [
        "序号",
        "经办单位",
        "订单日期",
        "专区",
        "商品",
        "订单数(笔)",
        "累计采购金额(元)"
      ];
      ws1.columns = [
        { key: "auto", width: 5 },
        { key: "orgName", width: 55 },
        { key: "orderDate", width: 25 },
        { key: "prefecture", width: 25 },
        { key: "commodity", width: 25 },
        { key: "orderQuantity", width: 25 },
        { key: "purchaseAmount", width: 25 }
      ];
      this.excelArr.forEach((item, idx) => {
        ws1.addRow([
          idx + 1,
          item.orgName,
          item.orderDate,
          item.prefecture,
          item.commodity,
          item.orderQuantity,
          item.purchaseAmount
        ]);
      });
      ws1.getRow(3).font = { bold: true, color: { argb: "000000" } };
      ws1.getRow(3).fill = { color: { argb: "000000" } };
      ws1.getRow(1).alignment = { vertical: "middle", horizontal: "center" };
      ws1.getRow(3).alignment = { vertical: "middle" };
      ws1.getRow(2).alignment = { vertical: "middle", horizontal: "left" };
      ws1.mergeCells("A1:G1");
      if (this.excelArr[0]) {
        const { orderQuantitySum, purchaseAmountSum } = this.excelArr[0];
        ws1.addRow([
          "合计",
          "——",
          "——",
          "——",
          "——",
          orderQuantitySum,
          purchaseAmountSum
        ]).alignment = {
          vertical: "middle",
          horizontal: "left"
        };
      }
      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf]), "商品采购统计表.xlsx");
    },
    handlExport() {
      this.exportDefault();
    },
    numberFilter(oldNum, isFixed) {
      return numberFilter(oldNum, isFixed);
    },
    headerDragend() {
      this.tableHack = false;
      this.$nextTick(() => {
        this.tableHack = true;
      });
    },
    pointEvent() {
      window.addEventListener("beforeprint", event => {
        let acfun = document.getElementsByClassName(
          "el-table__header-wrapper"
        )[0];
        acfun.style.display = "none";
      });
      window.addEventListener("afterprint", event => {
        this.acfun = false;
        let acfun = document.getElementsByClassName(
          "el-table__header-wrapper"
        )[0];
        acfun.style.display = "table";
        let acfuns = document.getElementsByClassName("el-table__body")[0];
        acfuns.removeChild(acfuns.childNodes[2]);
      });
    },
    // Todo 表格所需函数 end

    // Todo 高级搜索所需函数 start
    searchItem(searchData) {
      this.searchData = searchData;
      // this.tableParams = {...this.tableParams, ...searchData };
      // console.log(this.tableParams);
      this.getData();
    }
    // Todo 高级搜索所需函数 end
  },
  beforeRouteLeave(to, from, next) {
    for (var key in this.$vnode.parent.componentInstance.cache) {
      delete this.$vnode.parent.componentInstance.cache[
        ishasAgentId(to.path, key)
      ];
    }
    next();
  }
};
</script>
<style lang="scss" scoped>
@media print {
  .el-table {
    width: initial !important;
    border: 1px solid #f1f1f1;
  }
  @page {
    size: A4 landscape;
    margin: 0;
  }
}
</style>
